import { Country, Deployment, Network } from '../model/Deployment';

export const mapOnlyDeployments: Deployment[] = [
  {
    photo: 'agel-poliklinika.png',
    name: 'Poliklinika AGEL Olomouc',
    network: 'agel',
    url: 'https://poliklinika.agel.cz/olomouc.html',
    latitude: 49.5916508,
    longitude: 17.2763164,
  },
  {
    photo: 'agel-poliklinika.png',
    name: 'Poliklinika AGEL Česká Třebová',
    network: 'agel',
    url: 'https://poliklinika.agel.cz/ceska-trebova.html',
    latitude: 49.8979758,
    longitude: 16.4480164,
  },
  {
    photo: 'agel-poliklinika.png',
    name: 'Poliklinika AGEL Plzeň',
    network: 'agel',
    url: 'https://poliklinika.agel.cz/plzen.html',
    latitude: 49.7458553,
    longitude: 13.3935442,
  },
  {
    photo: 'agel-poliklinika.png',
    name: 'Poliklinika AGEL Praha',
    network: 'agel',
    url: 'https://poliklinika.agel.cz/praha.html',
    latitude: 50.08463547953291,
    longitude: 14.480604151684819,
  },
  {
    photo: 'agel-poliklinika.png',
    name: 'Poliklinika AGEL Bor',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/dopravni-zdravotnictvi/bor',
    latitude: 49.71435293995311,
    longitude: 12.775242050182515,
  },
  {
    photo: 'agel-poliklinika.png',
    name: 'Poliklinika AGEL Přeštice',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/dopravni-zdravotnictvi/prestice',
    latitude: 49.57327588453963,
    longitude: 13.325095895021459,
  },
  {
    photo: 'agel-poliklinika.png',
    name: 'Poliklinika AGEL Liberec',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/dopravni-zdravotnictvi',
    latitude: 50.76135532296445,
    longitude: 15.094787593132677,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Bílovec',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/laboratore-agel/bilovec',
    latitude: 49.7630078,
    longitude: 18.0174781,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Brno',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/laboratore-agel/brno',
    latitude: 49.1944361,
    longitude: 16.633195,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Havířov',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/laboratore-agel/havirov',
    latitude: 49.7880925,
    longitude: 18.4360175,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Louny',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/laboratore-agel/louny',
    latitude: 50.3499028,
    longitude: 13.8082453,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Studénka',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/laboratore-agel/studenka',
    latitude: 49.7066192,
    longitude: 18.0512472,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Praha',
    network: 'agel',
    url: 'https://www.agellab.cz/',
    latitude: 50.08459594445942,
    longitude: 14.481055316641031,
  },
  // Laboratoře AGEL Ústí nad Labem a.s. is a company of its own in the AGEL group
  // (not Laboratoře AGEL a.s.), with a workplace in Most.
  {
    photo: 'agel.png',
    name: 'Laboratoře AGEL Ústí nad Labem',
    network: 'agel',
    url: 'https://lau.agel.cz/',
    latitude: 50.661428,
    longitude: 14.0334362,
  },
  {
    photo: 'agel.png',
    name: 'Laboratoře AGEL Ústí nad Labem – pracoviště Most',
    network: 'agel',
    url: 'https://lau.agel.cz/',
    latitude: 50.4988608,
    longitude: 13.6318196,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Šternberk',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/laboratore-agel/sternberk',
    latitude: 49.72245042051796,
    longitude: 17.29817552667766,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Ostrava',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/laboratore-agel/ostrava1',
    latitude: 49.814780838482555,
    longitude: 18.268737051182793,
  },
  {
    photo: 'laboratore-agel.png',
    name: 'Laboratoře AGEL Nový Jičín',
    network: 'agel',
    url: 'https://www.agellab.cz/pracoviste/laboratore-agel/novy-jicin2',
    latitude: 49.58861209631775,
    longitude: 18.007187817821098,
  },
  {
    photo: 'agel-hornicka.png',
    name: 'AGEL Hornická poliklinika',
    network: 'agel',
    url: 'https://hornickapoliklinika.agel.cz/index.html',
    latitude: 49.8460583,
    longitude: 18.2853503,
  },
  {
    photo: 'agel-stredmoravska.png',
    name: 'Nemocnice AGEL Prostějov',
    network: 'agel',
    url: 'https://nemocniceprostejov.agel.cz/index.html',
    latitude: 49.4756767,
    longitude: 17.0883058,
  },
  {
    photo: 'agel-stredmoravska.png',
    name: 'Nemocnice AGEL Přerov',
    network: 'agel',
    url: 'https://nemocniceprerov.agel.cz/index.html',
    latitude: 49.4568719,
    longitude: 17.4736642,
  },
  {
    photo: 'agel-stredmoravska.png',
    name: 'Nemocnice AGEL Šternberk',
    network: 'agel',
    url: 'https://nemocnicesternberk.agel.cz/index.html',
    latitude: 49.7224597,
    longitude: 17.2981497,
  },
  {
    photo: 'agel-stredmoravska.png',
    name: 'AGEL Středomoravská nemocniční Konice',
    network: 'agel',
    url: 'https://laborator.smn.agel.cz/index.html',
    latitude: 49.592850831638906,
    longitude: 16.886706850336644,
  },
  {
    photo: 'agel-stredmoravska.png',
    name: 'AGEL Středomoravská nemocniční Litovel',
    network: 'agel',
    url: 'https://laborator.smn.agel.cz/index.html',
    latitude: 49.70259567483459,
    longitude: 17.076254621143256,
  },
  {
    photo: 'agel-tesin.png',
    name: 'Nemocnice AGEL Český Těšín',
    network: 'agel',
    url: 'https://nemocniceceskytesin.agel.cz/index.html',
    latitude: 49.7466047,
    longitude: 18.6101922,
  },
  {
    photo: 'agel-jesenik.png',
    name: 'Nemocnice AGEL Jeseník',
    network: 'agel',
    url: 'https://nemocnicejesenik.agel.cz/index.html',
    latitude: 50.2277803,
    longitude: 17.1983369,
  },
  {
    photo: 'agel-novy-jicin.png',
    name: 'Nemocnice AGEL Nový Jičín',
    network: 'agel',
    url: 'https://nemocnicenovyjicin.agel.cz/index.html',
    latitude: 49.5899358,
    longitude: 18.0067608,
  },
  {
    photo: 'agel-ostrava.png',
    name: 'Nemocnice AGEL Ostrava-Vítkovice',
    network: 'agel',
    url: 'https://nemocniceostravavitkovice.agel.cz/index.html',
    latitude: 49.8147344,
    longitude: 18.2686836,
  },
  {
    photo: 'szz-krnov.svg',
    name: 'Nemocnice Rýmařov',
    url: 'https://www.nemocnicerymarov.cz/',
    latitude: 49.9314125,
    longitude: 17.2624231,
  },
  {
    photo: 'szz-krnov.svg',
    name: 'Nemocnice Bruntál',
    url: 'https://www.nemocnicebruntal.cz/',
    latitude: 49.9947314616796,
    longitude: 17.471429330904606,
  },
  {
    photo: 'agel-ricany.png',
    name: 'Nemocnice AGEL Říčany',
    network: 'agel',
    url: 'https://nemocnicericany.agel.cz/index.html',
    latitude: 49.9960536,
    longitude: 14.6751492,
  },
  {
    photo: 'agel-trinec.png',
    name: 'Nemocnice AGEL Třinec-Podlesí',
    network: 'agel',
    url: 'https://nemocnicetrinecpodlesi.agel.cz/index.html',
    latitude: 49.6810156,
    longitude: 18.6413453,
  },
  {
    photo: 'agel-mezirici.png',
    name: 'Nemocnice AGEL Valašské Meziříčí',
    network: 'agel',
    url: 'https://nemocnicevalasskemezirici.agel.cz/index.html',
    latitude: 49.4629172,
    longitude: 17.9770236,
  },
  {
    photo: 'npk-pardubice.svg',
    name: 'Pardubická nemocnice',
    network: 'npk',
    url: 'https://pardubice.nempk.cz/',
    latitude: 50.029324921779796,
    longitude: 15.787584261772217,
  },
  {
    photo: 'npk-chrudim.svg',
    name: 'Chrudimská nemocnice',
    network: 'npk',
    url: 'https://chrudim.nempk.cz/',
    latitude: 49.9419582999511,
    longitude: 15.807776681304617,
  },
  {
    photo: 'npk-litomysl.svg',
    name: 'Litomyšlská nemocnice',
    network: 'npk',
    url: 'https://litomysl.nempk.cz/',
    latitude: 49.864714719023866,
    longitude: 16.31326031647276,
  },
  {
    photo: 'npk-orlickoustecka.svg',
    name: 'Orlickoústecká nemocnice',
    network: 'npk',
    url: 'https://usti.nempk.cz/',
    latitude: 49.97018200741024,
    longitude: 16.402964674518316,
  },
  {
    photo: 'npk-svitavy.svg',
    name: 'Svitavská nemocnice',
    network: 'npk',
    url: 'https://svitavy.nempk.cz/',
    latitude: 49.75293249932078,
    longitude: 16.469749567830895,
  },
  {
    photo: 'jicin.jpg',
    name: 'OKB Nový Bydžov',
    url: 'https://www.nemjc.cz/odeleni-klinicke-biochemie-2',
    latitude: 50.24317746444454,
    longitude: 15.481925464299415,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Praha',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 50.07035880892531,
    longitude: 14.404193864745901,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Hradec Králové',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 50.21059094421603,
    longitude: 15.829863780395584,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place České Budějovice',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 48.97294728353397,
    longitude: 14.487208103472055,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Ústí nad Labem',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 50.662979335046145,
    longitude: 14.033158786030258,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Jihlava',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 49.39280291607055,
    longitude: 15.595010381277321,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Olomouc',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 49.59238301573026,
    longitude: 17.27554308307836,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Liberec',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 50.768832009406175,
    longitude: 15.060008460534489,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Brno',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 49.198227823439915,
    longitude: 16.606354887311124,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Plzeň',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 49.748320785438416,
    longitude: 13.375421742320222,
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place Pardubice',
    network: 'plasmaPlace',
    url: 'https://www.plasmaplace.cz/',
    latitude: 50.0364648625547,
    longitude: 15.770432534296443,
  },
  {
    photo: 'penta-hospitals.png',
    name: 'Nemocnice Vrchlabí - Penta Hospitals',
    network: 'penta',
    url: 'https://www.pentahospitals.cz/nemocnice-vrchlabi/',
    latitude: 50.6220617,
    longitude: 15.6071954,
  },
  {
    photo: 'penta-hospitals.png',
    name: 'Nemocnice Sokolov - Penta Hospitals',
    network: 'penta',
    url: 'https://www.pentahospitals.cz/nemocnice-sokolov/',
    latitude: 50.17792657916654,
    longitude: 12.65064465077026,
  },
  {
    photo: 'penta-hospitals.png',
    name: 'Nemocnice Roudnice nad Labem - Penta Hospitals',
    network: 'penta',
    url: 'https://www.pentahospitals.cz/nemocnice-roudnice/',
    latitude: 50.4223249,
    longitude: 14.2485453,
  },
  {
    photo: 'penta-hospitals.png',
    name: 'Nemocnice Ostrov - Penta Hospitals',
    network: 'penta',
    url: 'https://www.pentahospitals.cz/nemocnice-ostrov/',
    latitude: 50.3122314,
    longitude: 12.9638984,
  },
  {
    photo: 'mild-blue.svg',
    name: 'Mild Blue',
    url: 'https://www.mild.blue/',
    latitude: 50.07224,
    longitude: 14.39644,
  },
];

export const logosOnlyDeployments: Deployment[] = [
  {
    photo: 'agel.png',
    name: 'Agel',
    url: 'https://www.agel.cz/index.html',
  },
  {
    photo: 'npk.jpg',
    name: 'Nemocnice Pardubického kraje',
    url: 'https://www.nempk.cz/',
  },
  {
    photo: 'plasma-place.png',
    name: 'Plasma Place',
    url: 'https://www.plasmaplace.cz/',
  },
  {
    photo: 'penta-hospitals.png',
    name: 'Penta Hospitals',
    url: 'https://www.pentahospitals.cz/',
  },
];

export const standaloneDeployments: Deployment[] = [
  {
    photo: 'bulovka.png',
    name: 'Fakultní nemocnice Bulovka',
    url: 'https://www.bulovka.cz/',
    latitude: 50.115354619737786,
    longitude: 14.464328428977112,
  },
  {
    photo: 'caslav.png',
    name: 'Městská nemocnice Čáslav',
    url: 'https://www.nemcaslav.cz/',
    latitude: 49.903995,
    longitude: 15.40156,
  },
  {
    photo: 'dvur_kralove.png',
    name: 'Městská nemocnice Dvůr Králové',
    url: 'https://www.mndk.cz/',
    latitude: 50.44860047555829,
    longitude: 15.815930168695246,
  },
  {
    photo: 'frydek-mistek.png',
    name: 'Nemocnice ve Frýdku-Místku',
    url: 'https://www.nemfm.cz/',
    latitude: 49.69085754445918,
    longitude: 18.354078341691203,
  },
  {
    photo: 'genemed.png',
    name: 'GENEMED – centrum lékařské genetiky',
    url: 'https://www.genemed.cz/',
    latitude: 49.83018,
    longitude: 18.1564176,
  },
  {
    photo: 'havirov.png',
    name: 'Nemocnice Havířov',
    url: 'https://www.nemocnicehavirov.cz/',
    latitude: 49.78432773706571,
    longitude: 18.438345541546525,
  },
  {
    photo: 'havlickuv-brod.png',
    name: 'Nemocnice Havlíčkův Brod',
    url: 'https://www.nemhb.cz/',
    latitude: 49.6091,
    longitude: 15.5714641,
  },
  {
    photo: 'horice.png',
    name: 'Levitovo centrum následné péče Hořice',
    url: 'http://www.naslednapece-horice.cz/',
    latitude: 50.368916444585835,
    longitude: 15.640165217610214,
  },
  {
    photo: 'cheb.svg',
    name: 'Nemocnice Cheb',
    url: 'https://nemcheb.cz/',
    latitude: 50.069699703704714,
    longitude: 12.366121454392461,
  },
  {
    photo: 'ikem.png',
    name: 'Institut klinické a experimentální medicíny',
    url: 'https://www.ikem.cz/',
    latitude: 50.02278748217662,
    longitude: 14.463166776508295,
  },
  {
    photo: 'jablonec.png',
    name: 'Nemocnice Jablonec nad Nisou',
    url: 'https://www.nemjbc.cz/',
    latitude: 50.7293008,
    longitude: 15.1595619,
  },
  {
    photo: 'jicin.jpg',
    name: 'Oblastní nemocnice Jičín',
    url: 'http://www.nemjc.cz',
    latitude: 50.44016662569661,
    longitude: 15.357406362107394,
  },
  {
    photo: 'jihlava.png',
    name: 'Nemocnice Jihlava',
    url: 'https://www.nemji.cz/',
    latitude: 49.39761588907566,
    longitude: 15.571065982595854,
  },
  {
    photo: 'jindrichuv-hradec.png',
    name: 'Nemocnice Jindřichův Hradec',
    url: 'https://www.nemjh.cz/',
    latitude: 49.13882228123841,
    longitude: 15.003398262990286,
  },
  {
    photo: 'karlovy_vary.jpg',
    name: 'Karlovarská krajská nemocnice',
    url: 'https://kkn.cz/',
    latitude: 50.23270126300806,
    longitude: 12.876812990909348,
  },
  {
    photo: 'karvina_raj.png',
    name: 'Nemocnice Karviná-Ráj',
    url: 'https://www.nspka.cz/',
    latitude: 49.84916644066578,
    longitude: 18.550803203445728,
  },
  {
    photo: 'kladno.jpg',
    name: 'Oblastní nemocnice Kladno',
    url: 'http://www.nemocnicekladno.cz/',
    latitude: 50.142159178035946,
    longitude: 14.087597533638549,
  },
  {
    photo: 'krevni-centrum.png',
    name: 'Krevní centrum',
    url: 'https://www.krevnicentrum.cz/',
    latitude: 49.6834570829065,
    longitude: 18.35523561745232,
  },
  {
    photo: 'fnkv.jpg',
    name: 'FN Královské Vinohrady',
    url: 'https://www.fnkv.cz/',
    latitude: 50.07623692570967,
    longitude: 14.475545797596228,
  },
  {
    photo: 'monitoring.webp',
    name: 'Monitoring',
    url: 'https://moni.cz/',
    latitude: 50.0690215,
    longitude: 14.5292217,
  },
  {
    photo: 'opava.png',
    name: 'Moravskoslezská nemocnice Opava',
    url: 'https://msnopava.cz/',
    latitude: 49.934794,
    longitude: 17.878532,
  },
  {
    photo: 'fn_ostrava.png',
    name: 'Fakultní nemocnice Ostrava',
    url: 'https://www.fno.cz/',
    latitude: 49.83055186538595,
    longitude: 18.15930174409706,
  },
  {
    photo: 'olu-paseka.svg',
    name: 'Odborný léčebný ústav Paseka',
    url: 'https://www.olupaseka.cz/',
    latitude: 49.8095613,
    longitude: 17.227925,
  },
  {
    photo: 'pelhrimov.png',
    name: 'Nemocnice Pelhřimov',
    url: 'https://www.hospital-pe.cz/',
    latitude: 49.43384195276211,
    longitude: 15.230011594055641,
  },
  {
    photo: 'pisek.png',
    name: 'Nemocnice Písek',
    url: 'https://www.nemopisek.cz/',
    latitude: 49.302754302792636,
    longitude: 14.15577592158033,
  },
  {
    photo: 'fn-plzen.png',
    name: 'Fakultní nemocnice Plzeň',
    url: 'https://www.fnplzen.cz/',
    latitude: 49.76248412545493,
    longitude: 13.380054675836144,
  },
  {
    photo: 'prachatice.png',
    name: 'Nemocnice Prachatice',
    url: 'https://nempt.cz/',
    latitude: 49.007397374295145,
    longitude: 14.010887467764656,
  },
  {
    photo: 'prevedig.svg',
    name: 'PREVEDIG medical',
    url: 'https://prevedig.cz/',
    latitude: 50.1294263,
    longitude: 14.4219103,
  },
  {
    photo: 'pribram.png',
    name: 'Oblastní nemocnice Příbram',
    url: 'https://www.nemocnicepribram.cz/',
    latitude: 49.69173807581391,
    longitude: 14.010299466279179,
  },
  {
    photo: 'rakovnik.png',
    name: 'Masarykova nemocnice Rakovník',
    url: 'https://nemorako.cz/',
    latitude: 50.1080820336798,
    longitude: 13.715318775553426,
  },
  {
    photo: 'revmatologicky-ustav.jpg',
    name: 'Revmatologický ústav',
    url: 'https://www.revma.cz/',
    latitude: 50.0677833,
    longitude: 14.4213022,
  },
  {
    photo: 'slany.jpg',
    name: 'Nemocnice Slaný',
    url: 'https://www.nemsl.cz/',
    latitude: 50.23451955201612,
    longitude: 14.08439633328783,
  },
  {
    photo: 'susice.png',
    name: 'Sušická nemocnice',
    url: 'https://www.susnem.cz/',
    latitude: 49.23012057791173,
    longitude: 13.526506330487987,
  },
  {
    photo: 'logo_ftn.webp',
    name: 'Fakultní Thomayerova nemocnice',
    url: 'https://www.ftn.cz/',
    latitude: 50.03015593059098,
    longitude: 14.457937135830033,
  },
  {
    photo: 'tabor.jpg',
    name: 'Nemocnice Tábor',
    url: 'https://www.nemta.cz/',
    latitude: 49.41738840800041,
    longitude: 14.652697810092999,
  },
  {
    photo: 'trnava.png',
    name: 'Fakultná nemocnica Trnava',
    country: 'sk',
    url: 'https://fntt.sk/',
    latitude: 48.367777234930045,
    longitude: 17.589311256902914,
  },
  {
    photo: 'trutnov.png',
    name: 'Oblastní nemocnice Trutnov',
    url: 'https://www.nemtru.cz/',
    latitude: 50.560176126977325,
    longitude: 15.920043195187837,
  },
  {
    photo: 'znojmo.webp',
    name: 'Nemocnice Znojmo',
    url: 'https://webext1.nemzn.cz/',
    latitude: 48.8694403,
    longitude: 16.0508003,
  },
  {
    photo: 'semmelweis_logo_horizontal.svg',
    name: 'Semmelweis University 1769',
    country: 'hu',
    url: 'https://semmelweis.hu/english/',
    latitude: 47.48717,
    longitude: 19.067172,
  },
  {
    photo: 'kbc-rijeka.jpg',
    name: 'Klinički bolnički centar Rijeka',
    country: 'hr',
    url: 'https://kbc-rijeka.hr/klinicki-zavod-za-laboratorijsku-dijagnostiku/',
    latitude: 45.3321,
    longitude: 14.4254,
  },
];

const logoOf = (photo: string): Deployment => logosOnlyDeployments.find((deployment) => deployment.photo === photo)!;

/** The logo entry of each healthcare network on the map. */
export const networkLogos: Record<Network, Deployment> = {
  agel: logoOf('agel.png'),
  npk: logoOf('npk.jpg'),
  plasmaPlace: logoOf('plasma-place.png'),
  penta: logoOf('penta-hospitals.png'),
};

/**
 * Deployments whose logo is shown right on the map, with the offset of the logo
 * from the site in map units (see deploymentsMapShapes.ts), placed over the
 * neighbouring countries so that the logos do not cover other sites. The logos
 * of sites in Prague are offset from the site enlarged in the Prague inset.
 */
export const mapCallouts: { name: string; dx: number; dy: number }[] = [
  { name: 'Institut klinické a experimentální medicíny', dx: 2, dy: 34 },
  { name: 'Fakultní nemocnice Bulovka', dx: 0, dy: -42 },
  { name: 'Fakultní nemocnice Plzeň', dx: -45, dy: 100 },
  { name: 'Fakultní nemocnice Ostrava', dx: -60, dy: -78 },
  { name: 'Fakultná nemocnica Trnava', dx: 95, dy: -40 },
  { name: 'Semmelweis University 1769', dx: 15, dy: 37 },
  { name: 'Klinički bolnički centar Rijeka', dx: 83, dy: 35 },
  { name: 'FN Královské Vinohrady', dx: -100, dy: 36 },
  { name: 'Fakultní Thomayerova nemocnice', dx: -108, dy: -22 },
  { name: 'Mild Blue', dx: -76, dy: -42 },
];

/** Cities shown on the deployments map for orientation, with the side their name is on. */
export const mapCities: { key: string; latitude: number; longitude: number; side: 'left' | 'right' | 'above' | 'below'; capital?: boolean }[] = [
  { key: 'praha', latitude: 50.0755, longitude: 14.4378, side: 'left', capital: true },
  { key: 'brno', latitude: 49.1951, longitude: 16.6068, side: 'below' },
  { key: 'ostrava', latitude: 49.8209, longitude: 18.2625, side: 'above' },
  { key: 'plzen', latitude: 49.7384, longitude: 13.3736, side: 'below' },
  { key: 'olomouc', latitude: 49.5938, longitude: 17.2509, side: 'left' },
  { key: 'hradecKralove', latitude: 50.2092, longitude: 15.8328, side: 'above' },
  { key: 'ceskeBudejovice', latitude: 48.9747, longitude: 14.4743, side: 'below' },
  { key: 'liberec', latitude: 50.7663, longitude: 15.0543, side: 'right' },
  { key: 'karlovyVary', latitude: 50.2319, longitude: 12.871, side: 'above' },
  { key: 'jihlava', latitude: 49.3961, longitude: 15.5912, side: 'below' },
  { key: 'znojmo', latitude: 48.8555, longitude: 16.0488, side: 'below' },
  { key: 'bratislava', latitude: 48.1486, longitude: 17.1077, side: 'right', capital: true },
  { key: 'zilina', latitude: 49.2231, longitude: 18.7394, side: 'right' },
  { key: 'kosice', latitude: 48.7164, longitude: 21.2611, side: 'above' },
  { key: 'budapest', latitude: 47.4979, longitude: 19.0402, side: 'left', capital: true },
  { key: 'vienna', latitude: 48.2082, longitude: 16.3738, side: 'left', capital: true },
  { key: 'wroclaw', latitude: 51.1079, longitude: 17.0385, side: 'below' },
  { key: 'zagreb', latitude: 45.815, longitude: 15.9819, side: 'right', capital: true },
  { key: 'rijeka', latitude: 45.3271, longitude: 14.4422, side: 'below' },
];

/** Boundary of Prague (OpenStreetMap relation, simplified), as latitude, longitude pairs. */
const pragueOutline: [number, number][] = [
  [50.103, 14.2244],
  [50.1035, 14.2498],
  [50.0963, 14.261],
  [50.0871, 14.2611],
  [50.0876, 14.2733],
  [50.0811, 14.2753],
  [50.0771, 14.2894],
  [50.0709, 14.2786],
  [50.0715, 14.2581],
  [50.0644, 14.2587],
  [50.0583, 14.2481],
  [50.0543, 14.2716],
  [50.0401, 14.2701],
  [50.028, 14.2872],
  [50.0236, 14.3159],
  [50.007, 14.3115],
  [50.0118, 14.3008],
  [50.0022, 14.2948],
  [49.9889, 14.3181],
  [49.9906, 14.3428],
  [49.9887, 14.3353],
  [49.9808, 14.3396],
  [49.9719, 14.3268],
  [49.9747, 14.3462],
  [49.9676, 14.3449],
  [49.9649, 14.3292],
  [49.9572, 14.3254],
  [49.9476, 14.3429],
  [49.9498, 14.388],
  [49.9419, 14.3956],
  [49.9707, 14.4006],
  [49.9636, 14.4194],
  [49.9739, 14.4446],
  [49.9708, 14.4622],
  [49.981, 14.4663],
  [49.9857, 14.487],
  [49.9924, 14.4839],
  [49.9975, 14.5073],
  [49.9926, 14.5137],
  [50.0007, 14.53],
  [50.0077, 14.521],
  [50.0108, 14.5275],
  [50.0074, 14.5683],
  [50.0164, 14.5824],
  [50.011, 14.5817],
  [50.0094, 14.6023],
  [49.9986, 14.6103],
  [49.9944, 14.6402],
  [49.9988, 14.6469],
  [50.0058, 14.6383],
  [50.0043, 14.6578],
  [50.0188, 14.6695],
  [50.031, 14.6561],
  [50.0378, 14.657],
  [50.0385, 14.6669],
  [50.0493, 14.6539],
  [50.0422, 14.644],
  [50.0569, 14.6402],
  [50.0721, 14.7],
  [50.087, 14.7068],
  [50.0963, 14.6887],
  [50.1006, 14.6903],
  [50.1065, 14.6574],
  [50.1226, 14.6591],
  [50.1239, 14.6352],
  [50.1299, 14.6323],
  [50.1295, 14.6005],
  [50.1452, 14.5877],
  [50.1541, 14.599],
  [50.1502, 14.5632],
  [50.1616, 14.561],
  [50.1661, 14.5505],
  [50.1616, 14.5342],
  [50.1772, 14.5325],
  [50.1774, 14.5269],
  [50.1695, 14.4669],
  [50.1599, 14.4641],
  [50.1577, 14.4281],
  [50.1498, 14.4225],
  [50.1479, 14.4],
  [50.1414, 14.3949],
  [50.148, 14.3657],
  [50.1375, 14.3541],
  [50.116, 14.3608],
  [50.1152, 14.3206],
  [50.1286, 14.3159],
  [50.1301, 14.3024],
  [50.1162, 14.2883],
  [50.1118, 14.2388],
  [50.1073, 14.2393],
];

/** Boundaries of the other cities drawn as areas on the map (OpenStreetMap, simplified). */
const ostravaOutline: [number, number][] = [
  [49.8301, 18.0984],
  [49.8306, 18.1137],
  [49.835, 18.129],
  [49.825, 18.1419],
  [49.8079, 18.1349],
  [49.8062, 18.1523],
  [49.7708, 18.1389],
  [49.766, 18.1423],
  [49.7587, 18.1752],
  [49.7413, 18.1843],
  [49.7406, 18.2369],
  [49.7258, 18.2559],
  [49.7307, 18.27],
  [49.7439, 18.2696],
  [49.7509, 18.2982],
  [49.7591, 18.3058],
  [49.781, 18.2953],
  [49.7807, 18.3304],
  [49.7724, 18.3474],
  [49.7993, 18.3644],
  [49.8017, 18.3763],
  [49.8181, 18.362],
  [49.8418, 18.3661],
  [49.8471, 18.3453],
  [49.864, 18.3495],
  [49.879, 18.3422],
  [49.8828, 18.3344],
  [49.8707, 18.3193],
  [49.8777, 18.3011],
  [49.9028, 18.3252],
  [49.9138, 18.32],
  [49.9059, 18.3187],
  [49.9042, 18.3072],
  [49.8862, 18.2884],
  [49.8802, 18.2747],
  [49.8832, 18.2608],
  [49.8624, 18.2278],
  [49.8674, 18.2103],
  [49.856, 18.2062],
  [49.864, 18.1973],
  [49.8592, 18.1949],
  [49.8642, 18.188],
  [49.8597, 18.1642],
  [49.8723, 18.145],
  [49.865, 18.1423],
  [49.8743, 18.1323],
  [49.8636, 18.1314],
  [49.861, 18.1196],
  [49.8473, 18.1143],
  [49.8413, 18.1043],
  [49.833, 18.1126],
];
const brnoOutline: [number, number][] = [
  [49.2167, 16.428],
  [49.2101, 16.4464],
  [49.1934, 16.458],
  [49.1926, 16.4745],
  [49.1981, 16.4718],
  [49.1992, 16.4795],
  [49.1961, 16.4932],
  [49.1845, 16.4969],
  [49.1784, 16.5149],
  [49.1643, 16.5294],
  [49.1687, 16.5489],
  [49.1529, 16.5584],
  [49.1569, 16.5766],
  [49.1616, 16.5751],
  [49.1588, 16.5939],
  [49.1358, 16.5897],
  [49.1373, 16.6317],
  [49.1461, 16.6339],
  [49.1451, 16.6403],
  [49.1318, 16.642],
  [49.1318, 16.6323],
  [49.1141, 16.6242],
  [49.11, 16.6353],
  [49.1178, 16.6337],
  [49.1155, 16.6798],
  [49.126, 16.6862],
  [49.1301, 16.7077],
  [49.1455, 16.7124],
  [49.1485, 16.7002],
  [49.1633, 16.6955],
  [49.172, 16.7048],
  [49.1763, 16.6942],
  [49.1851, 16.6944],
  [49.1934, 16.7208],
  [49.2118, 16.7121],
  [49.2171, 16.7199],
  [49.2197, 16.7132],
  [49.2199, 16.7188],
  [49.2266, 16.7155],
  [49.2371, 16.7278],
  [49.2449, 16.7242],
  [49.2439, 16.7135],
  [49.2178, 16.6815],
  [49.2193, 16.6731],
  [49.225, 16.6647],
  [49.2335, 16.6733],
  [49.2471, 16.6413],
  [49.2512, 16.6476],
  [49.2621, 16.6427],
  [49.2781, 16.6176],
  [49.2867, 16.6489],
  [49.2944, 16.6301],
  [49.2852, 16.628],
  [49.2936, 16.5992],
  [49.2857, 16.5949],
  [49.2829, 16.5788],
  [49.2709, 16.5749],
  [49.2658, 16.5533],
  [49.2635, 16.5608],
  [49.2536, 16.5622],
  [49.2528, 16.5528],
  [49.2593, 16.5494],
  [49.2506, 16.54],
  [49.2549, 16.532],
  [49.2508, 16.528],
  [49.2412, 16.5324],
  [49.2433, 16.517],
  [49.2569, 16.5019],
  [49.2635, 16.5083],
  [49.2718, 16.4953],
  [49.2827, 16.4627],
  [49.2656, 16.4471],
  [49.2534, 16.455],
  [49.252, 16.4487],
  [49.2511, 16.4543],
  [49.2347, 16.4327],
  [49.2319, 16.4397],
];
const plzenOutline: [number, number][] = [
  [49.774, 13.268],
  [49.7657, 13.2917],
  [49.7377, 13.2855],
  [49.7371, 13.3078],
  [49.7338, 13.2976],
  [49.7247, 13.306],
  [49.7169, 13.2945],
  [49.6951, 13.3049],
  [49.6845, 13.3023],
  [49.6792, 13.3157],
  [49.6845, 13.3242],
  [49.6808, 13.3651],
  [49.6897, 13.383],
  [49.6895, 13.4024],
  [49.6809, 13.4025],
  [49.6802, 13.4426],
  [49.6844, 13.448],
  [49.703, 13.429],
  [49.7106, 13.4375],
  [49.7073, 13.4413],
  [49.7077, 13.4451],
  [49.7148, 13.4414],
  [49.7207, 13.4516],
  [49.735, 13.4505],
  [49.7393, 13.467],
  [49.762, 13.4758],
  [49.7628, 13.4698],
  [49.7751, 13.4718],
  [49.777, 13.4289],
  [49.787, 13.4316],
  [49.7796, 13.4133],
  [49.8058, 13.4013],
  [49.8007, 13.3515],
  [49.787, 13.3632],
  [49.7755, 13.3474],
  [49.778, 13.3255],
  [49.795, 13.2881],
];
const olomoucOutline: [number, number][] = [
  [49.5813, 17.1621],
  [49.5764, 17.1664],
  [49.5866, 17.2007],
  [49.5809, 17.2142],
  [49.5738, 17.2003],
  [49.5653, 17.2018],
  [49.559, 17.1834],
  [49.5475, 17.1895],
  [49.5527, 17.2102],
  [49.5454, 17.2224],
  [49.5478, 17.2572],
  [49.5347, 17.2761],
  [49.556, 17.306],
  [49.5586, 17.3027],
  [49.5665, 17.328],
  [49.5755, 17.3211],
  [49.5783, 17.3331],
  [49.5885, 17.3277],
  [49.5917, 17.3003],
  [49.5991, 17.3007],
  [49.6045, 17.3333],
  [49.6129, 17.3451],
  [49.6125, 17.3594],
  [49.6028, 17.3603],
  [49.6013, 17.3682],
  [49.6061, 17.3837],
  [49.6125, 17.3914],
  [49.6219, 17.3803],
  [49.6217, 17.3961],
  [49.6373, 17.3829],
  [49.644, 17.3952],
  [49.6452, 17.3486],
  [49.6362, 17.3316],
  [49.6319, 17.3393],
  [49.6234, 17.3322],
  [49.622, 17.3167],
  [49.6321, 17.3034],
  [49.6359, 17.3064],
  [49.6331, 17.283],
  [49.6246, 17.2696],
  [49.636, 17.2586],
  [49.6304, 17.2474],
  [49.662, 17.2406],
  [49.6489, 17.2222],
  [49.6213, 17.2344],
  [49.6141, 17.2168],
  [49.6097, 17.2194],
  [49.6061, 17.1956],
  [49.6027, 17.1984],
  [49.6038, 17.1741],
  [49.5985, 17.1676],
  [49.5824, 17.172],
];
const hradecKraloveOutline: [number, number][] = [
  [50.2258, 15.7468],
  [50.2156, 15.7729],
  [50.2016, 15.7712],
  [50.1991, 15.757],
  [50.1873, 15.7635],
  [50.1833, 15.7556],
  [50.1728, 15.7709],
  [50.168, 15.8043],
  [50.1628, 15.8003],
  [50.16, 15.8094],
  [50.1776, 15.81],
  [50.1744, 15.819],
  [50.1639, 15.8187],
  [50.1613, 15.8285],
  [50.1617, 15.8462],
  [50.1693, 15.8503],
  [50.1605, 15.8617],
  [50.1637, 15.9166],
  [50.182, 15.9271],
  [50.2048, 15.925],
  [50.2044, 15.935],
  [50.2163, 15.9152],
  [50.2237, 15.9147],
  [50.2236, 15.9068],
  [50.2327, 15.9196],
  [50.2444, 15.9145],
  [50.2448, 15.8674],
  [50.2476, 15.8629],
  [50.2568, 15.872],
  [50.2655, 15.8576],
  [50.2659, 15.8345],
  [50.2602, 15.8303],
  [50.2534, 15.8342],
  [50.2469, 15.8243],
  [50.2508, 15.7917],
  [50.2436, 15.789],
  [50.2422, 15.7786],
  [50.2352, 15.7803],
  [50.2366, 15.7531],
];
const ceskeBudejoviceOutline: [number, number][] = [
  [48.9974, 14.3869],
  [48.983, 14.4076],
  [48.9884, 14.4281],
  [48.9681, 14.4335],
  [48.9629, 14.4623],
  [48.9588, 14.4568],
  [48.953, 14.466],
  [48.9334, 14.4612],
  [48.9514, 14.4867],
  [48.9442, 14.5042],
  [48.9503, 14.508],
  [48.9493, 14.5167],
  [48.9573, 14.5065],
  [48.9635, 14.5092],
  [48.9599, 14.5171],
  [48.9603, 14.518],
  [48.9735, 14.5203],
  [48.977, 14.5134],
  [48.9953, 14.5213],
  [49.0126, 14.4922],
  [49.0087, 14.4632],
  [49.0199, 14.4505],
  [49.0079, 14.4221],
  [49.0089, 14.3923],
];
const liberecOutline: [number, number][] = [
  [50.7797, 14.953],
  [50.751, 14.9822],
  [50.7424, 14.9785],
  [50.7325, 14.984],
  [50.7094, 15.0266],
  [50.7145, 15.0376],
  [50.7207, 15.0325],
  [50.7253, 15.0459],
  [50.7161, 15.0671],
  [50.7197, 15.063],
  [50.7278, 15.0735],
  [50.71, 15.0936],
  [50.708, 15.1071],
  [50.715, 15.1093],
  [50.723, 15.1268],
  [50.7368, 15.1038],
  [50.7449, 15.1267],
  [50.7555, 15.1244],
  [50.7545, 15.1352],
  [50.7721, 15.1357],
  [50.7755, 15.1469],
  [50.791, 15.1277],
  [50.7938, 15.113],
  [50.8073, 15.1217],
  [50.8063, 15.0709],
  [50.8243, 15.0372],
  [50.8002, 14.9973],
  [50.8034, 14.9875],
  [50.7983, 14.9719],
  [50.7935, 14.9728],
  [50.7973, 14.9604],
  [50.7913, 14.9594],
  [50.789, 14.971],
];
const karlovyVaryOutline: [number, number][] = [
  [50.2394, 12.7849],
  [50.2324, 12.8202],
  [50.2262, 12.8136],
  [50.2214, 12.8179],
  [50.2218, 12.809],
  [50.2172, 12.8121],
  [50.2067, 12.7985],
  [50.1864, 12.8412],
  [50.1995, 12.8387],
  [50.1958, 12.866],
  [50.2082, 12.8718],
  [50.1958, 12.8756],
  [50.1894, 12.8853],
  [50.2016, 12.9147],
  [50.1966, 12.926],
  [50.2029, 12.9415],
  [50.211, 12.9352],
  [50.2171, 12.944],
  [50.2219, 12.9296],
  [50.2326, 12.9337],
  [50.24, 12.9295],
  [50.2354, 12.9057],
  [50.2421, 12.8871],
  [50.2505, 12.8869],
  [50.2467, 12.8655],
  [50.2583, 12.8522],
  [50.2668, 12.8526],
  [50.2658, 12.8144],
  [50.2548, 12.8026],
  [50.2493, 12.8067],
];
const jihlavaOutline: [number, number][] = [
  [49.3853, 15.4983],
  [49.3807, 15.5122],
  [49.3728, 15.508],
  [49.3545, 15.5246],
  [49.3497, 15.5134],
  [49.3447, 15.5208],
  [49.334, 15.5212],
  [49.3348, 15.535],
  [49.3447, 15.5559],
  [49.3598, 15.5513],
  [49.3573, 15.5623],
  [49.3682, 15.5509],
  [49.3752, 15.5941],
  [49.367, 15.6115],
  [49.3774, 15.6108],
  [49.3716, 15.637],
  [49.3727, 15.6432],
  [49.3781, 15.642],
  [49.3805, 15.6596],
  [49.3928, 15.6502],
  [49.4002, 15.6306],
  [49.4087, 15.6382],
  [49.4121, 15.6555],
  [49.425, 15.6623],
  [49.4307, 15.6443],
  [49.426, 15.6387],
  [49.4366, 15.6468],
  [49.4434, 15.6393],
  [49.446, 15.6192],
  [49.4549, 15.6177],
  [49.4562, 15.6118],
  [49.4566, 15.6181],
  [49.4601, 15.6086],
  [49.4629, 15.6145],
  [49.4711, 15.6049],
  [49.4739, 15.5748],
  [49.4625, 15.5531],
  [49.426, 15.5764],
  [49.4189, 15.5544],
  [49.4272, 15.5358],
  [49.4196, 15.5446],
  [49.4167, 15.5382],
  [49.417, 15.5437],
  [49.416, 15.5299],
  [49.412, 15.535],
  [49.4077, 15.5211],
  [49.4063, 15.5318],
  [49.3989, 15.5321],
  [49.3973, 15.539],
  [49.3968, 15.5167],
  [49.3904, 15.5136],
  [49.3946, 15.5002],
];
const znojmoOutline: [number, number][] = [
  [48.9104, 15.9683],
  [48.9036, 15.9762],
  [48.8989, 15.9715],
  [48.8923, 15.9817],
  [48.8918, 15.9992],
  [48.8693, 16.0036],
  [48.8668, 16.0125],
  [48.8569, 16.0053],
  [48.8507, 15.9844],
  [48.8397, 15.9783],
  [48.8334, 15.9781],
  [48.8212, 15.9986],
  [48.8115, 16.0208],
  [48.821, 16.0441],
  [48.8277, 16.0416],
  [48.8341, 16.049],
  [48.8432, 16.019],
  [48.8523, 16.0355],
  [48.8482, 16.0513],
  [48.834, 16.0594],
  [48.8337, 16.0667],
  [48.8271, 16.0674],
  [48.8166, 16.0557],
  [48.8019, 16.0621],
  [48.802, 16.0787],
  [48.8098, 16.0789],
  [48.8123, 16.0965],
  [48.8013, 16.1393],
  [48.8028, 16.1584],
  [48.8078, 16.1467],
  [48.815, 16.1513],
  [48.8295, 16.1164],
  [48.8461, 16.1083],
  [48.842, 16.08],
  [48.8465, 16.0718],
  [48.8542, 16.08],
  [48.8624, 16.0769],
  [48.8712, 16.0618],
  [48.8659, 16.0524],
  [48.8708, 16.059],
  [48.8787, 16.0456],
  [48.882, 16.0603],
  [48.8997, 16.0361],
  [48.9113, 16.0328],
  [48.8991, 16.0195],
  [48.9111, 15.9974],
  [48.9113, 16.0047],
];
const bratislavaOutline: [number, number][] = [
  [48.2367, 16.946],
  [48.2232, 16.9605],
  [48.1904, 16.9761],
  [48.1722, 16.9762],
  [48.1412, 17.0261],
  [48.1437, 17.0572],
  [48.1242, 17.0688],
  [48.1215, 17.0628],
  [48.0996, 17.0927],
  [48.0966, 17.0878],
  [48.0914, 17.0931],
  [48.0809, 17.0716],
  [48.0782, 17.0789],
  [48.0705, 17.0722],
  [48.0654, 17.0868],
  [48.0554, 17.0682],
  [48.0457, 17.0878],
  [48.0314, 17.0674],
  [48.0198, 17.0899],
  [48.0312, 17.1101],
  [48.0209, 17.1267],
  [48.0202, 17.1438],
  [48.0067, 17.1608],
  [48.02, 17.201],
  [48.0162, 17.2266],
  [48.0206, 17.2405],
  [48.0396, 17.2231],
  [48.0538, 17.1874],
  [48.0639, 17.1944],
  [48.0617, 17.2021],
  [48.0705, 17.2008],
  [48.0795, 17.2119],
  [48.0857, 17.2067],
  [48.0957, 17.2177],
  [48.1035, 17.2173],
  [48.1123, 17.2455],
  [48.1001, 17.2762],
  [48.1167, 17.2845],
  [48.1442, 17.2375],
  [48.1621, 17.2343],
  [48.164, 17.2272],
  [48.1681, 17.2373],
  [48.1818, 17.2179],
  [48.1985, 17.2316],
  [48.2185, 17.2093],
  [48.2446, 17.1646],
  [48.2384, 17.1533],
  [48.2428, 17.1342],
  [48.2476, 17.137],
  [48.2498, 17.0814],
  [48.2356, 17.0738],
  [48.2455, 17.0472],
  [48.2521, 17.0442],
  [48.2481, 17.0184],
  [48.2523, 16.9872],
  [48.2651, 16.9585],
];
const zilinaOutline: [number, number][] = [
  [49.2424, 18.6615],
  [49.2331, 18.6877],
  [49.22, 18.6812],
  [49.2039, 18.7052],
  [49.1974, 18.6788],
  [49.1841, 18.6804],
  [49.1787, 18.6938],
  [49.1849, 18.7221],
  [49.1764, 18.7277],
  [49.1726, 18.7417],
  [49.1646, 18.7427],
  [49.1633, 18.7511],
  [49.1964, 18.7497],
  [49.1958, 18.7675],
  [49.2008, 18.7722],
  [49.1799, 18.7827],
  [49.163, 18.8154],
  [49.1844, 18.8138],
  [49.1859, 18.8348],
  [49.1946, 18.832],
  [49.2159, 18.7722],
  [49.232, 18.768],
  [49.2339, 18.7978],
  [49.2408, 18.7993],
  [49.2518, 18.7946],
  [49.2651, 18.7724],
  [49.2689, 18.7795],
  [49.278, 18.76],
  [49.2657, 18.7499],
  [49.2657, 18.7291],
  [49.272, 18.7224],
  [49.2592, 18.7265],
  [49.2504, 18.712],
  [49.245, 18.6865],
  [49.2504, 18.669],
  [49.245, 18.6702],
];
const kosiceOutline: [number, number][] = [
  [48.7634, 21.12],
  [48.7312, 21.1763],
  [48.724, 21.1688],
  [48.7173, 21.1862],
  [48.6963, 21.1996],
  [48.6972, 21.1785],
  [48.6705, 21.1825],
  [48.6556, 21.1759],
  [48.6581, 21.1494],
  [48.6684, 21.1508],
  [48.6552, 21.1217],
  [48.638, 21.1296],
  [48.62, 21.1215],
  [48.6174, 21.1702],
  [48.5942, 21.1718],
  [48.581, 21.1826],
  [48.57, 21.2206],
  [48.5773, 21.2404],
  [48.6105, 21.224],
  [48.6128, 21.2297],
  [48.6209, 21.2286],
  [48.636, 21.2107],
  [48.6482, 21.2292],
  [48.6446, 21.2689],
  [48.6529, 21.3179],
  [48.6417, 21.3582],
  [48.6574, 21.3553],
  [48.6592, 21.3494],
  [48.6742, 21.3499],
  [48.6893, 21.329],
  [48.7068, 21.3303],
  [48.7123, 21.3194],
  [48.7167, 21.33],
  [48.7208, 21.3202],
  [48.7302, 21.3266],
  [48.7368, 21.3242],
  [48.739, 21.3135],
  [48.7451, 21.3172],
  [48.7625, 21.3019],
  [48.7769, 21.3049],
  [48.7934, 21.2959],
  [48.7969, 21.286],
  [48.7922, 21.2752],
  [48.8007, 21.2719],
  [48.7841, 21.2635],
  [48.7796, 21.2409],
  [48.7713, 21.2444],
  [48.7742, 21.224],
  [48.7765, 21.2296],
  [48.7813, 21.2233],
  [48.7818, 21.2291],
  [48.7891, 21.2196],
  [48.8041, 21.1771],
  [48.8228, 21.1599],
  [48.8242, 21.1497],
  [48.8086, 21.1305],
  [48.7896, 21.1442],
  [48.7825, 21.1425],
  [48.7847, 21.1258],
  [48.7664, 21.1259],
];
const budapestOutline: [number, number][] = [
  [47.5441, 18.9251],
  [47.5433, 18.9358],
  [47.5226, 18.9353],
  [47.5222, 18.9269],
  [47.5175, 18.9448],
  [47.5071, 18.9339],
  [47.4993, 18.9455],
  [47.4915, 18.9359],
  [47.4824, 18.9471],
  [47.4823, 18.9637],
  [47.4608, 18.9827],
  [47.4512, 18.97],
  [47.4472, 18.9785],
  [47.4319, 18.9774],
  [47.4186, 18.957],
  [47.3993, 18.9625],
  [47.3926, 18.9513],
  [47.3726, 18.9624],
  [47.387, 18.9947],
  [47.385, 19.044],
  [47.4049, 19.0836],
  [47.391, 19.094],
  [47.387, 19.1052],
  [47.3787, 19.0982],
  [47.3497, 19.1405],
  [47.3611, 19.1797],
  [47.3955, 19.2058],
  [47.4074, 19.2261],
  [47.4128, 19.2171],
  [47.4242, 19.2317],
  [47.4192, 19.247],
  [47.4382, 19.2658],
  [47.4363, 19.2809],
  [47.4572, 19.3013],
  [47.4632, 19.3349],
  [47.4777, 19.3298],
  [47.493, 19.3142],
  [47.5153, 19.3183],
  [47.5083, 19.2636],
  [47.5369, 19.2449],
  [47.5327, 19.2211],
  [47.5403, 19.2094],
  [47.539, 19.1903],
  [47.5595, 19.1611],
  [47.5643, 19.1744],
  [47.5781, 19.1454],
  [47.585, 19.1538],
  [47.5998, 19.1381],
  [47.598, 19.128],
  [47.6131, 19.0993],
  [47.5891, 19.0746],
  [47.6069, 19.0767],
  [47.6096, 19.0382],
  [47.6046, 19.0253],
  [47.5869, 19.0345],
  [47.5838, 18.9938],
  [47.589, 18.983],
  [47.5857, 18.9778],
  [47.5831, 18.9851],
  [47.5739, 18.9772],
  [47.5789, 18.9426],
  [47.5724, 18.9288],
  [47.5508, 18.9408],
];
const viennaOutline: [number, number][] = [
  [48.1711, 16.1818],
  [48.164, 16.1962],
  [48.1541, 16.1982],
  [48.1555, 16.2035],
  [48.1532, 16.2232],
  [48.1476, 16.2099],
  [48.1356, 16.2208],
  [48.1372, 16.2384],
  [48.132, 16.2386],
  [48.1259, 16.2147],
  [48.1238, 16.2189],
  [48.1339, 16.2711],
  [48.1295, 16.2979],
  [48.1194, 16.3118],
  [48.1378, 16.3246],
  [48.1179, 16.4083],
  [48.1231, 16.4229],
  [48.1199, 16.437],
  [48.1379, 16.4331],
  [48.1395, 16.4554],
  [48.1574, 16.4776],
  [48.1585, 16.5165],
  [48.1433, 16.543],
  [48.1352, 16.576],
  [48.1504, 16.5775],
  [48.1632, 16.5731],
  [48.1645, 16.5499],
  [48.1771, 16.5495],
  [48.1766, 16.541],
  [48.1729, 16.5447],
  [48.1734, 16.5367],
  [48.1914, 16.5418],
  [48.2004, 16.5363],
  [48.239, 16.5527],
  [48.2428, 16.5394],
  [48.263, 16.547],
  [48.2678, 16.5129],
  [48.2736, 16.5067],
  [48.2855, 16.5149],
  [48.2925, 16.4964],
  [48.2935, 16.4812],
  [48.2734, 16.4812],
  [48.2764, 16.4723],
  [48.2919, 16.4404],
  [48.3168, 16.4378],
  [48.3227, 16.4199],
  [48.3171, 16.3817],
  [48.3017, 16.3862],
  [48.2959, 16.3756],
  [48.2883, 16.3779],
  [48.2868, 16.3671],
  [48.2817, 16.3706],
  [48.2837, 16.3535],
  [48.2905, 16.3481],
  [48.2772, 16.329],
  [48.2714, 16.2913],
  [48.2671, 16.286],
  [48.264, 16.2941],
  [48.2549, 16.2641],
  [48.2519, 16.2704],
  [48.2399, 16.2566],
  [48.2383, 16.2415],
  [48.2428, 16.2373],
  [48.2484, 16.2411],
  [48.2635, 16.2067],
  [48.2432, 16.1935],
  [48.2286, 16.1991],
  [48.2232, 16.1852],
  [48.2229, 16.1978],
  [48.2143, 16.1978],
  [48.2096, 16.2096],
  [48.2048, 16.2019],
  [48.2023, 16.2074],
  [48.1862, 16.1998],
];
const wroclawOutline: [number, number][] = [
  [51.1389, 16.8073],
  [51.1414, 16.8265],
  [51.1264, 16.8171],
  [51.1243, 16.8333],
  [51.1162, 16.8429],
  [51.1172, 16.8365],
  [51.1152, 16.8364],
  [51.1138, 16.8315],
  [51.1118, 16.8307],
  [51.1121, 16.8582],
  [51.1072, 16.854],
  [51.1003, 16.859],
  [51.0934, 16.8873],
  [51.099, 16.8897],
  [51.0978, 16.9229],
  [51.0811, 16.9172],
  [51.082, 16.9379],
  [51.0674, 16.9581],
  [51.0587, 16.9551],
  [51.0496, 16.9645],
  [51.0577, 16.9909],
  [51.0516, 16.9922],
  [51.0551, 17.0087],
  [51.0465, 17.0099],
  [51.0427, 17.0279],
  [51.0501, 17.0313],
  [51.0452, 17.0609],
  [51.0591, 17.0673],
  [51.0468, 17.0855],
  [51.0453, 17.1034],
  [51.0509, 17.1072],
  [51.0594, 17.0958],
  [51.0792, 17.1114],
  [51.0818, 17.1503],
  [51.0888, 17.1622],
  [51.0945, 17.1601],
  [51.0959, 17.1714],
  [51.1007, 17.1691],
  [51.1063, 17.1762],
  [51.1278, 17.1369],
  [51.1448, 17.1506],
  [51.1785, 17.1573],
  [51.1802, 17.1323],
  [51.1707, 17.1249],
  [51.1768, 17.0845],
  [51.1628, 17.0784],
  [51.1755, 17.0271],
  [51.1859, 17.0225],
  [51.1818, 16.9999],
  [51.1975, 17.0009],
  [51.2094, 16.958],
  [51.1967, 16.9226],
  [51.2101, 16.9033],
  [51.2036, 16.8821],
  [51.191, 16.8877],
  [51.1887, 16.9018],
  [51.1841, 16.9005],
  [51.1878, 16.8818],
  [51.1794, 16.8723],
  [51.1775, 16.855],
  [51.1836, 16.8276],
  [51.1718, 16.8211],
  [51.1577, 16.8311],
  [51.1503, 16.8131],
];

/**
 * Cities drawn as their outline instead of a point, as on the map they are bigger
 * than the point; their name goes next to the outline.
 */
export const cityOutlines: Record<string, [number, number][]> = {
  praha: pragueOutline,
  ostrava: ostravaOutline,
  brno: brnoOutline,
  plzen: plzenOutline,
  olomouc: olomoucOutline,
  hradecKralove: hradecKraloveOutline,
  ceskeBudejovice: ceskeBudejoviceOutline,
  liberec: liberecOutline,
  karlovyVary: karlovyVaryOutline,
  jihlava: jihlavaOutline,
  znojmo: znojmoOutline,
  bratislava: bratislavaOutline,
  zilina: zilinaOutline,
  kosice: kosiceOutline,
  budapest: budapestOutline,
  vienna: viennaOutline,
  wroclaw: wroclawOutline,
};

/**
 * Areas where the sites are too close to tell apart, shown enlarged instead:
 * `zoom` times bigger, with the centre (`latitude`, `longitude`) at `x`, `y` in
 * map units. An area is a circle of `radius` map units, or the `outline` of a
 * city as latitude, longitude pairs (the OpenStreetMap boundary, simplified).
 */
export const mapInsets: { key: 'praha' | 'ostrava'; latitude: number; longitude: number; radius?: number; outline?: [number, number][]; zoom: number; x: number; y: number }[] = [
  { key: 'praha', latitude: 50.075, longitude: 14.45, outline: pragueOutline, zoom: 5, x: 160, y: 352 },
  { key: 'ostrava', latitude: 49.74, longitude: 18.3, radius: 30, zoom: 3.3, x: 612, y: 126 },
];

/**
 * Towns named inside an inset only, with their point drawn over the sites'. The
 * name starts `dx`, `dy` map units from the town's position, right beside its point
 * on the side where it covers the fewest sites.
 */
export const mapInsetCities: { key: string; inset: 'praha' | 'ostrava'; latitude: number; longitude: number; dx: number; dy: number }[] = [
  { key: 'ostrava', inset: 'ostrava', latitude: 49.8209, longitude: 18.2625, dx: 12, dy: -4 },
  { key: 'trinec', inset: 'ostrava', latitude: 49.6776, longitude: 18.6708, dx: -46, dy: 3.5 },
  { key: 'havirov', inset: 'ostrava', latitude: 49.7798, longitude: 18.4369, dx: -20.3, dy: 12 },
  { key: 'frydekMistek', inset: 'ostrava', latitude: 49.6851, longitude: 18.3483, dx: -79.9, dy: 3.5 },
  { key: 'novyJicin', inset: 'ostrava', latitude: 49.5944, longitude: 18.0103, dx: 5, dy: 3.5 },
];

/**
 * Countries too far off the map to fit in, shown whole in a box of their own in
 * a free corner of the map instead, as Alaska and Hawaii are on maps of the
 * USA, so that their outline tells them apart: the area around `latitude`,
 * `longitude`, `zoom` times the map's scale, in a `width` by `height` box
 * centred at `x`, `y` in map units. `key` is the country.
 */
export const mapBoxes: { key: Country; latitude: number; longitude: number; zoom: number; width: number; height: number; x: number; y: number }[] = [
  { key: 'hr', latitude: 44.55, longitude: 16.55, zoom: 0.38, width: 160, height: 162, x: 630, y: 350 },
];

/**
 * Landmarks drawn in an inset for orientation. Landmarks too close to another
 * one or to a site are shifted by `dx`, `dy` map units of the inset.
 */
export const mapLandmarks: {
  key: 'castle' | 'petrin' | 'vysehrad' | 'vitkov' | 'lysaHora';
  inset: 'praha' | 'ostrava';
  latitude: number;
  longitude: number;
  dx?: number;
  dy?: number;
}[] = [
  { key: 'castle', inset: 'praha', latitude: 50.0909, longitude: 14.4005, dx: -21, dy: -1 },
  { key: 'petrin', inset: 'praha', latitude: 50.0836, longitude: 14.3951, dx: -21, dy: 16 },
  { key: 'vysehrad', inset: 'praha', latitude: 50.0643, longitude: 14.4178, dx: -4, dy: 27 },
  { key: 'vitkov', inset: 'praha', latitude: 50.0883, longitude: 14.4486, dx: 20, dy: -15 },
  // Lysá hora, the highest peak of the Moravian-Silesian Beskydy, with its transmitter.
  { key: 'lysaHora', inset: 'ostrava', latitude: 49.546, longitude: 18.4475 },
];
